(() => {
  const initializeToolbar = (toolbar) => {
    if (!toolbar || toolbar.dataset.initialized === 'true') return;
    toolbar.dataset.initialized = 'true';

    const backButton = toolbar.querySelector('[data-bh-gallery-back]');
    const gallery = toolbar.closest('.variant-media-gallery');
    let scrollFrame = 0;

    const syncProductScroll = () => {
      scrollFrame = 0;
      if (!gallery || !window.matchMedia('(max-width: 749px)').matches) {
        gallery?.style.removeProperty('--bh-product-scroll-progress');
        return;
      }

      const main = gallery.querySelector(
        '.variant-media-gallery__group:not([hidden]) .variant-media-gallery__main'
      ) || gallery.querySelector('.variant-media-gallery__main');
      if (!main) return;

      const galleryTop = gallery.getBoundingClientRect().top;
      const distance = Math.max(180, main.getBoundingClientRect().height * .62);
      const linearProgress = Math.max(0, Math.min(1, (-galleryTop - 6) / distance));
      const easedProgress = 1 - Math.pow(1 - linearProgress, 2);

      /* Evita que el redondeo de subpíxeles en iOS alterne la capa cerca de 0. */
      const stableProgress = easedProgress < .008
        ? 0
        : easedProgress > .992
          ? 1
          : easedProgress;

      gallery.style.setProperty('--bh-product-scroll-progress', stableProgress.toFixed(3));
    };

    const queueProductScrollSync = () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(syncProductScroll);
    };

    window.addEventListener('scroll', queueProductScrollSync, { passive: true });
    window.addEventListener('resize', queueProductScrollSync, { passive: true });
    queueProductScrollSync();

    backButton?.addEventListener('click', () => {
      if (window.history.length > 1) {
        window.history.back();
        return;
      }

      window.location.assign(toolbar.dataset.homeUrl || '/');
    });

  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-bh-product-gallery-toolbar]').forEach(initializeToolbar);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
